// extracted by mini-css-extract-plugin
export default {"button":"DeleteClassModalConfirmationStage_button__Kp-0t"};